import React, { useState } from "react";
import { Order } from "./types";

// Selected (unpaid) — the talent's unpaid selections with a per-row Delete
// (the confirm modal stays on the page). Moved out of pages/AdminDjProfile.tsx
// in the Phase C split; renders nothing when there is nothing unpaid.
export function DjUnpaidOrders({ orders, setDeleteId }: { orders: Order[]; setDeleteId: (id: string) => void }) {
  const [showUnpaid, setShowUnpaid] = useState(false);
  const unpaid = orders.filter((o) => !o.paid);
  if (unpaid.length === 0) return null;
  return (
    <div className="adm-card">
      <div
        className="card-header-flex"
        style={{ cursor: "pointer", marginBottom: showUnpaid ? 12 : 0 }}
        onClick={() => setShowUnpaid((v) => !v)}
      >
        <h2 className="adm-section-title">
          <span style={{ display: "inline-block", transition: "transform 0.2s", transform: showUnpaid ? "rotate(90deg)" : "rotate(0deg)", fontSize: "0.7rem", marginRight: 8 }}>▶</span>
          Selected (unpaid) ({unpaid.length})
        </h2>
      </div>
      {showUnpaid && (
      <div className="adm-scrollable-full" style={{ maxHeight: 460 }}>
        <table className="adm-table-light adm-table-compact sticky-header adm-w-full">
          <thead>
            <tr>
              <th style={{ width: "44%" }}>Track</th>
              <th style={{ width: "12%" }}>Amount</th>
              <th style={{ width: "18%" }}>Client</th>
              <th style={{ width: "16%" }}>Date</th>
              <th style={{ width: "10%" }}></th>
            </tr>
          </thead>
          <tbody>
            {unpaid.map((o) => (
              <tr key={o._id} className="hover-row">
                <td className="adm-clip-cell">
                  <span className="adm-ellipsis" title={o.searchQuery}>
                    {o.searchQuery}
                  </span>
                </td>
                <td className="adm-bold adm-nowrap">
                  {(o.currency || "usd").toUpperCase()} {o.amount.toFixed(2)}
                </td>
                <td className="adm-clip-cell">
                  <span
                    className="adm-ellipsis adm-fs-76"
                    title={[o.customerName, o.clientInstagram ? `@${o.clientInstagram}` : null, o.customerEmail, o.clientNickname, o.cardLast4 ? `•••• ${o.cardLast4}` : null].filter(Boolean).join(" | ") || undefined}
                  >
                    {o.customerName || (o.clientInstagram ? `@${o.clientInstagram}` : null) || o.customerEmail || o.clientNickname || (o.cardLast4 ? `•••• ${o.cardLast4}` : null) || "—"}
                  </span>
                </td>
                <td className="muted-text adm-fs-76 adm-nowrap">
                  {new Date(o.createdAt).toLocaleDateString()}{" "}
                  {new Date(o.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                </td>
                <td>
                  <button
                    className="adm-btn-sm adm-btn-red-sm"
                    onClick={() => setDeleteId(o._id)}
                    title="Delete order"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {unpaid.length === 0 && (
              <tr>
                <td colSpan={5} className="adm-center adm-p-24 adm-grey">
                  No unpaid selections
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      )}
    </div>
  );
}
